"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../lib");

var _common = require("../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var range = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.object, _propTypes.default.instanceOf(Date)]);

var Range =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Range, _PureComponent);

  function Range(_props) {
    var _this;

    _classCallCheck(this, Range);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Range).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "checkCondition", function (key, value) {
      var _this$props = _this.props,
          startCondition = _this$props.startCondition,
          endCondition = _this$props.endCondition;
      var _this$state = _this.state,
          startValue = _this$state.startValue,
          endValue = _this$state.endValue,
          min = _this$state.min,
          max = _this$state.max;

      if (key === 'start') {
        if (startCondition && endValue) {
          return startCondition({
            startValue: startValue,
            endValue: endValue,
            value: value,
            min: min,
            max: max
          });
        }

        return true;
      }

      if (key === 'end') {
        if (endCondition && startValue) {
          return endCondition({
            startValue: startValue,
            endValue: endValue,
            value: value,
            min: min,
            max: max
          });
        }

        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnStartChange", function (e, props) {
      if (e && e.stopPropagation) e.stopPropagation();

      if (props && (0, _lib.objHasOwnProperty)(props, 'value')) {
        var value = props.value;

        if (_this.checkCondition('start', value)) {
          _this.setState({
            startValue: value
          }, function () {
            _this.callOnChange(e);

            var onStartChange = _this.props.onStartChange;

            if (onStartChange) {
              onStartChange(e, {
                value: value
              });
            }
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnEndChange", function (e, props) {
      if (e && e.stopPropagation) e.stopPropagation();

      if (props && (0, _lib.objHasOwnProperty)(props, 'value')) {
        var value = props.value;

        if (_this.checkCondition('end', value)) {
          _this.setState({
            endValue: value
          }, function () {
            _this.callOnChange(e);

            var onEndChange = _this.props.onEndChange;

            if (onEndChange) {
              onEndChange(e, {
                value: value
              });
            }
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnStartClear", function (e) {
      _this.setState({
        startValue: ''
      }, function () {
        var startValue = _this.state.startValue;

        _this.callOnChange(e);

        var onStartChange = _this.props.onStartChange;

        if (onStartChange) {
          var falsyValue = (0, _lib.getFalsyValue)(startValue);
          onStartChange(e, {
            value: falsyValue
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnEndClear", function (e) {
      _this.setState({
        endValue: ''
      }, function () {
        var endValue = _this.state.endValue;

        _this.callOnChange(e);

        var onEndChange = _this.props.onEndChange;

        if (onEndChange) {
          var falsyValue = (0, _lib.getFalsyValue)(endValue);
          onEndChange(e, {
            value: falsyValue
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnStartReset", function (e) {
      var start = _this.props.start;

      _this.setState({
        startValue: start
      }, function () {
        _this.callOnChange(e);

        var onStartChange = _this.props.onStartChange;

        if (onStartChange) {
          onStartChange(e, {
            value: start
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnEndReset", function (e) {
      var end = _this.props.end;

      _this.setState({
        endValue: end
      }, function () {
        _this.callOnChange(e);

        var onEndChange = _this.props.onEndChange;

        if (onEndChange) {
          onEndChange(e, {
            value: end
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMinChange", function (e, _ref) {
      var value = _ref.value;

      _this.setState({
        min: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMaxChange", function (e, _ref2) {
      var value = _ref2.value;

      _this.setState({
        max: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "callOnChange", function (e) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          name = _this$props2.name;

      if (onChange) {
        var _this$state2 = _this.state,
            startValue = _this$state2.startValue,
            endValue = _this$state2.endValue,
            min = _this$state2.min,
            max = _this$state2.max;
        onChange(e, {
          name: name,
          value: [startValue, endValue],
          start: startValue,
          end: endValue,
          min: min,
          max: max
        });
      }
    });

    var _start = _props.start,
        _end = _props.end,
        _min = _props.min,
        _max = _props.max;
    _this.state = {
      prevProps: {
        start: _start,
        end: _end,
        min: _min,
        max: _max
      },
      startValue: _start,
      endValue: _end,
      min: _min,
      max: _max
    };
    return _this;
  }

  _createClass(Range, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state3 = this.state,
          startValue = _this$state3.startValue,
          endValue = _this$state3.endValue,
          min = _this$state3.min,
          max = _this$state3.max;
      return (0, _lib.getRenderProps)(children, {
        onStartChange: this.handleOnStartChange,
        onEndChange: this.handleOnEndChange,
        onStartClear: this.handleOnStartClear,
        onEndClear: this.handleOnEndClear,
        onStartReset: this.handleOnStartReset,
        onEndReset: this.handleOnEndReset,
        onMinChange: this.handleOnMinChange,
        onMaxChange: this.handleOnMaxChange,
        startValue: startValue,
        endValue: endValue,
        min: min,
        max: max
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var start = props.start,
          end = props.end,
          min = props.min,
          max = props.max;
      return {
        // Store the previous props in state
        prevProps: {
          start: start,
          end: end,
          min: min,
          max: max
        },
        startValue: prevProps.start !== start ? start : state.startValue,
        endValue: prevProps.end !== end ? end : state.endValue,
        min: prevProps.min !== min ? min : state.min,
        max: prevProps.max !== max ? max : state.max
      };
    }
  }]);

  return Range;
}(_react.PureComponent);

exports.default = Range;

_defineProperty(Range, "propTypes", {
  children: _common.customPropTypes.render.isRequired,
  start: range,
  end: range,
  min: range,
  max: range,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onStartChange: _propTypes.default.func,
  onEndChange: _propTypes.default.func,
  startCondition: _propTypes.default.func,
  endCondition: _propTypes.default.func
});

_defineProperty(Range, "defaultProps", {
  start: null,
  end: null,
  min: null,
  max: null,
  name: null,
  onChange: null,
  onStartChange: null,
  onEndChange: null,
  startCondition: function startCondition(_ref3) {
    var value = _ref3.value,
        endValue = _ref3.endValue,
        min = _ref3.min,
        max = _ref3.max;

    if (min && max) {
      return value < endValue && value >= min && value <= max;
    }

    if (min) {
      return value < endValue && value >= min;
    }

    if (max) {
      return value < endValue && value <= max;
    }

    return value < endValue;
  },
  endCondition: function endCondition(_ref4) {
    var value = _ref4.value,
        startValue = _ref4.startValue,
        min = _ref4.min,
        max = _ref4.max;

    if (min && max) {
      return value > startValue && value >= min && value <= max;
    }

    if (min) {
      return value > startValue && value >= min;
    }

    if (max) {
      return value > startValue && value <= max;
    }

    return value > startValue;
  }
});